import "./SearchBox.css";
import { Form } from "react-bootstrap";
import React, { useState } from "react";

const SearchBox = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchTerm);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    if (onSearch) {
      onSearch("");
    }
  };

  return (
    <>
      <div className="searchBox">
        <Form>
          <div className="row">
            <div className="col-lg-6 col-md-8 col-12">
              <Form.Group className="mb-lg-3 mb-md-3 mb-2">
                <Form.Control
                  placeholder="Search numbers..."
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-4 col-12">
              <button
                className="searchButton"
                type="button"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="clearButton"
                type="button"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SearchBox;
